/**
 * Notion color constants mapped to hex values.
 * @module utils/colors
 */

/** @type {Record<string, string>} Notion text colors */
export const NOTION_COLORS = {
  gray:   "#9B9A97",
  brown:  "#64473A",
  orange: "#D9730D",
  yellow: "#DFAB01",
  green:  "#0F7B6C",
  blue:   "#0B6E99",
  purple: "#6940A5",
  pink:   "#AD1A72",
  red:    "#E03E3E",
};

/** @type {Record<string, string>} Notion background colors */
export const NOTION_BG = {
  gray_background:   "#EBECED",
  brown_background:  "#E9E5E3",
  orange_background: "#FAEBDD",
  yellow_background: "#FBF3DB",
  green_background:  "#DDEDEA",
  blue_background:   "#DDEBF1",
  purple_background: "#EAE4F2",
  pink_background:   "#F4DFEB",
  red_background:    "#FBE4E4",
};
